import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { PoaTechoService } from '../../../services/formulacion/poa-techo.service';
import { CategoriaProgService } from '../../../services/formulacion/categoria-prog.service';
import { UnidadOrgService } from '../../../services/formulacion/unidad-org.service';
import { FuenteService } from '../../../services/formulacion/fuente.service';
import { OrganismoService } from '../../../services/formulacion/organismo.service';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;

@Component({
  selector: 'app-intervencion',
  templateUrl: './intervencion.component.html',
  styleUrls: [],
  providers: [PoaTechoService, CategoriaProgService, UnidadOrgService, FuenteService, OrganismoService, GeneralService]
})
export class IntervencionComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  dataResourceAgregacion: any[];
  dataResourceIN: any[];
  dataResourceCP: any[];
  dataResourceUO: any[];
  dataResourceUESigep: any[];
  dataResourceUE: any[];
  dataResourceFF: any[];
  dataResourceOR: any[];
  fuentesUP: any;
  dataUsers: any[];
  dataAT: any[];
  model: any = {
    id: 0,
    categoria_programatica: '',
    categoria_programatica_id: 0,
    descripcion_techo: '',
    unidad_organizacional: '',
    unidad_organizacional_id: 0,
    unidad_ejecutora_id: 0,
    tipo_gasto: '',
    tipo_gasto_id: 0,
    tipo_intervencion: '',
    tipo_intervencion_id: 0,
    unidad_ejecutora_sigep_id: 0,
    tipo_agregacion_id: 1,
    fuentes: []
  };
  tipo_agregacion_id: number = 1;
  fuentes: any = [{ id: 0, fuente_id: '', organismo_id: '', monto: '' }];
  techoId: number = 0;
  techoIdE: number = 0;
  estado: string = '0';
  popupVisibleAdd: boolean = false;
  popupVisibleDel: boolean = false;
  popupVisibleEstado: boolean = false;
  popupVisibleT: boolean = false;
  popupVisibleUs: boolean = false;
  popupVisibleUpdateFuentePpto: boolean = false;
  baseUrl = environment.apiEndpoint;
  estados: any = [{ id: 4, descripcion: 'Aprobado' }, { id: 3, descripcion: 'Observado' }];
  modelEstado: any = { id: 0, observaciones: '', estado_id: '' };
  modelT: any = { poa_techo_id: 0, tipo_apertura_id: '', motivo: '' };
  selectedRows: number[];
  catProg: string = '';
  interv: string = '';
  hasError: any;
  hasErrorE: any;
  hasErrorT: any;
  gestion: string;
  rol: number;

  constructor(private _ts: PoaTechoService, private _cs: CategoriaProgService, private _us: UnidadOrgService, private _fs: FuenteService, private _os: OrganismoService, private _gs: GeneralService) {

    let u = JSON.parse(localStorage.getItem('u'));
    this.rol = u.rol;
    this.tipo_agregacion_id = 1;
    this.gestion = JSON.parse(localStorage.getItem('g'));
    this.getCategoriaProgramatica();
    this.getUnidadOrganizacional();
    this.getUnidadEjecutora();
    this.getUnidadEjecutoraSigep();
    this.getFuente();
    this.getOrganismo();
    this.getTipoAperturas();
    this.clearErrors();
    this.getTipoAgregacion();
    this.getPoaTecho(this.estado, this.tipo_agregacion_id);

  }

  ngOnInit() {
  }

  clearErrors() {
    this.hasError = { descripcion_techo: false, categoria_programatica_id: false, unidad_organizacional_id: false, unidad_ejecutora_id: false, unidad_ejecutora_sigep_id: false, tipo_agregacion_id: false };
  }

  getPoaTecho(estado: string, tipo: number) {
    this._ts.getPoaTechoByGestion(estado, tipo).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceIN = result.data;

        } else {
          this.dataResourceIN = [];
        }
      },
      (error) => { console.log('Error', error); });
  }


  getTipoAgregacion() {
    this._ts.getTipoAgregacion().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceAgregacion = result.data;
        } else {
          this.dataResourceAgregacion = [];
        }
      },
      (error) => { console.log('Error', error); });
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'acciones'
    },
      {
        location: 'before',
        widget: 'dxSelectBox',
        options: {
          width: 200,
          items: [
            { value: '1', text: 'Elaboración' },
            { value: '2', text: 'Enviado a revisión' },
            { value: '3', text: 'Observado' },
            { value: '4', text: 'Aprobado' },
            { value: '0', text: 'Todos' }
          ],
          displayExpr: 'text',
          valueExpr: 'value',
          placeholder: 'Filtrar por estado',
          onValueChanged: this.refreshDataGrid.bind(this)
        }
      }
    );
  }

  refreshDataGrid(e) {
    this.getPoaTecho(e.value, this.tipo_agregacion_id);
    this.dataGrid.instance.refresh();
    this.estado = e.value;
  }

  showModalAdd() {
    this.clearErrors();
    this.model.id = 0;
    this.model.categoria_programatica_id = '';
    this.model.descripcion_techo = '';
    this.model.unidad_organizacional_id = '';
    this.model.unidad_ejecutora_id = '';
    this.model.tipo_gasto_id = 0;
    this.model.tipo_intervencion_id = 0;
    this.model.unidad_ejecutora_sigep_id = 0
    this.model.tipo_agregacion_id = 1;
    this.model.fuentes = [];
    this.fuentes = [{
      id: 0,
      fuente_id: '',
      organismo_id: '',
      monto: ''
    }];
    this.popupVisibleAdd = true;
  }

  showModalEdit(data: any) {
    this.clearErrors();

    this.model.id = data.id;
    this.model.descripcion_techo = data.descripcion_techo;
    this.model.categoria_programatica_id = data.categoria_programatica_id;
    this.model.unidad_organizacional_id = data.unidad_organizacional_id;
    this.model.unidad_ejecutora_id = data.unidad_ejecutora_id;
    this.model.unidad_ejecutora_sigep_id = data.unidad_ejecutora_sigep_id;
    this.model.tipo_agregacion_id = data.tipo_agregacion_id;
    this.fuentes = this.getFuentesPorTechoId(data.id);
    this.popupVisibleAdd = true;
  }

  showModalupdateTdfFuente(data: any) {
    this.fuentesUP = data;
    this.popupVisibleUpdateFuentePpto = true;
  }

  updateFuentePpto() {
    this._ts.updateFuentePpto(this.fuentesUP).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPoaTecho(this.estado, this.tipo_agregacion_id);
          this.popupVisibleUpdateFuentePpto = false;
          this.popupVisibleAdd = false;
        }
        else if (result.status == 201) {
          toastr.warning(result.data);
        }
        else if (result.status == 210) {
          toastr.warning(result.data);
        }
      },
      error => { console.log('Error', error); });


  }

  getFuentesPorTechoId(id: string) {
    this._fs.getFuentesPorTechoId(id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.fuentes = result.data;
        } else {
          this.fuentes = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  savePoaTecho(data: any) {    
    this.clearErrors();
    if (this.validate(data)) {    
      data.fuentes = [];
      for (let i = 0; i < this.fuentes.length; i++) {
        if (this.fuentes[i].fuente_id != '' && this.fuentes[i].organismo_id != '' && this.fuentes[i].monto >= 0) {
          data.fuentes.push(this.fuentes[i]);
        }
      }
      if (data.id == 0) {
        if (data.fuentes.length > 0) {

          this._ts.postPoaTecho(data).subscribe(
            response => {
              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getPoaTecho(this.estado, this.tipo_agregacion_id);
                toastr.success('Techo registrado correctamente.');
                this.popupVisibleAdd = false;
              }
              else if (result.status == 201) {
                toastr.warning(result.data);
              }
            },
            error => { console.log('Error', error); });
        } else {
          toastr.info('Ingrese datos de financiamiento');
        }
      }
      else {
        if (data.fuentes.length > 0) {

          this._ts.putPoaTecho(data).subscribe(
            response => {

              let result = UtilHelper.responses(response);
              if (result.status == 200) {
                this.getPoaTecho(this.estado, this.tipo_agregacion_id);
                this.popupVisibleAdd = false;
              }
              else if (result.status == 201) {
                toastr.warning(result.data);
              }
              else if (result.status == 210) {
                toastr.warning(result.data);
              }
            },
            error => { console.log('Error', error); });
        } else {
          toastr.info('Ingrese datos de financiamiento');
        }
      }
    }
  }

  showModalDelete(id: number) {
    this.techoId = id;
    this.popupVisibleDel = true;
  }

  deletePoaTecho() {
    this._ts.deletePoaTecho(this.techoId).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.getPoaTecho(this.estado, this.tipo_agregacion_id);
          this.popupVisibleDel = false;
        }
        if (result.status == 201) {
          toastr.warning('No se puede eliminar, el techo tiene dependencia.');
          this.popupVisibleDel = false;

        }
      },
      (error) => { console.log('Error', error); });
  }

  getCategoriaProgramatica() {
    this._cs.getCategoriaProgActivos().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceCP = result.data;
        } else {
          this.dataResourceCP = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getUnidadOrganizacional() {
    this._us.getUnidadOrgActivos().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceUO = result.data;
        } else {
          this.dataResourceUO = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getFuente() {
    this._fs.getFuentesVigentes().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceFF = result.data;
        } else {
          this.dataResourceFF = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getOrganismo() {
    this._os.getOrganismoVigentes().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceOR = result.data;
        } else {
          this.dataResourceOR = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  addFuente() {
    this.techoId++;
    this.fuentes.push({
      id: this.techoId,
      fuente_id: '',
      organismo_id: '',
      monto: ''
    });
  }

  removeFuente(id: number) {
    for (var i = 0; i < this.fuentes.length; i++) {
      if (this.fuentes[i].id == id) {
        this.fuentes.splice(i, 1);
        break;
      }
    }
  }

  validate(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.descripcion_techo, 'text')) {
      this.hasError.descripcion_techo = true; res = false;
    }
    if (!UtilHelper.validator(data.categoria_programatica_id, 'integer')) {
      this.hasError.categoria_programatica_id = true; res = false;
    }
    if (!UtilHelper.validator(data.unidad_organizacional_id, 'integer')) {
      this.hasError.unidad_organizacional_id = true; res = false;
    }
    if (!UtilHelper.validator(data.unidad_ejecutora_sigep_id, 'integer')) {
      this.hasError.unidad_ejecutora_sigep_id = true; res = false;
    }
    if (!UtilHelper.validator(data.tipo_agregacion_id, 'integer')) {
      this.hasError.tipo_agregacion_id = true; res = false;

    }

    return res;
  }

  getDescripcionCP(e: any) {
    this.model.descripcion_techo = this.dataResourceCP.filter(o => o.id == e.value).map(o => o.categoria).toString();
  }

  showModalRevisar(id: number) {
    this.modelEstado = { id: 0, observaciones: '', estado_id: '' };
    this.techoIdE = id;
    this.popupVisibleEstado = true;
    this.clearErrorsE();
  }

  saveEstadoPoaTecho() {
    this.modelEstado.id = this.techoIdE;
    if (this.validateE(this.modelEstado)) {
      this._ts.postPoaTechoEstado(this.modelEstado).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getPoaTecho(this.estado, this.tipo_agregacion_id);
            this.dataGrid.instance.refresh();
            this.popupVisibleEstado = false;
            toastr.success('Operación realizada exitosamente.');
          } else {
            toastr.info('Ocurrió un incoveniente al realizar la operación.');
          }
        },
        error => { console.log('Error', error); });
    }
  }

  clearErrorsE() {
    this.hasErrorE = { observaciones: false, estado_id: false };
  }

  validateE(data: any) {
    let res = true;
    if (!UtilHelper.validator(data.observaciones, 'text')) {
      this.hasErrorE.observaciones = true; res = false;
    }
    if (!UtilHelper.validator(data.estado_id, 'integer')) {
      this.hasErrorE.estado_id = true; res = false;
    }
    return res;
  }

  getUnidadEjecutora() {
    this._us.getUnidadEjecutora().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceUE = result.data;
        } else {
          this.dataResourceUE = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getUnidadEjecutoraSigep() {
    this._us.getUnidadEjecutoraSigep().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataResourceUESigep = result.data;
        } else {
          this.dataResourceUESigep = [];
        }
      },
      (error) => {
        console.log('Error', error);
      });
  }

  getTipoAperturas() {
    this._ts.getTipoAperturas().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataAT = result.data;
        } else {
          this.dataAT = [];
        }
      });
  }

  showModalApertura(id: number) {
    this.modelT = { poa_techo_id: id, tipo_apertura_id: '', motivo: '' };
    this.popupVisibleT = true;
    this.clearErrorsT();
  }

  clearErrorsT() {
    this.hasErrorT = { tipo_apertura_id: false, motivo: false };
  }

  saveAperturaT() {
    this.clearErrorsT();
    if (this.validateT()) {
      this._ts.postApertura(this.modelT).subscribe(
        response => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.getPoaTecho(this.estado, this.tipo_agregacion_id);
            this.popupVisibleT = false;
          }
        },
        error => { console.log('Error', error); });
    }
  }

  validateT() {
    let res = true;
    if (!UtilHelper.validator(this.modelT.motivo, 'text')) {
      this.hasErrorT.motivo = true; res = false;
    }
    if (!UtilHelper.validator(this.modelT.tipo_apertura_id, 'integer')) {
      this.hasErrorT.tipo_apertura_id = true; res = false;
    }
    return res;
  }

  showModalUser(dg: any) {
    this.techoId = dg.id;
    this._gs.getUsuariosAll(dg.id).subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          this.dataUsers = result.data;
          this.selectedRows = this.dataUsers.filter(u => u.seleccionado == 1).map(u => u);
        } else {
          this.dataUsers = [];
          this.selectedRows = [];
        }
      });
    this.catProg = dg.categoria_programatica;
    this.interv = dg.descripcion_techo;
    this.popupVisibleUs = true;
  }

  saveUsers(a: any) {
    this._gs.postUsuariosTecho({ techo_id: this.techoId, users: a.selectedRowKeys }).subscribe(
      response => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) {
          toastr.success('Usuarios asignados correctamente.');
          this.popupVisibleUs = false;
        }
      });
    this.techoId = 0;
    //console.log(a.selectedRowKeys);
  }

}
